module.exports = __webpack_public_path__ + "img/noreport.86613e21.png";